import { render, staticRenderFns } from "./IlpaNewReleaseDerechoVital.vue?vue&type=template&id=1a12166f&scoped=true"
import script from "./IlpaNewReleaseDerechoVital.vue?vue&type=script&lang=js"
export * from "./IlpaNewReleaseDerechoVital.vue?vue&type=script&lang=js"
import style0 from "./IlpaNewReleaseDerechoVital.vue?vue&type=style&index=0&id=1a12166f&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1a12166f",
  null
  
)

export default component.exports